import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'main-bmi-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bmi-card.component.html',
  styleUrl: './bmi-card.component.css'
})
export class BmiCardComponent {

  @Input() bmi: number = 0;
  @Input() change: number = 0;
  @Input() isPositive: boolean = true;
  @Input() date: string = '--';
  @Input() weight: number = 0;
  @Input() height: number = 0;

  isExpanded: boolean = false;

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  get indicatorPosition(): string {
    // Basic mapping: BMI bounds (e.g. 15 to 40)
    const min = 15;
    const max = 40;
    let clampedBmi = Math.max(min, Math.min(max, this.bmi));
    const percent = ((clampedBmi - min) / (max - min)) * 100;
    return `${percent}%`;
  }
}
